import React from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import SearchOrderHistoryContent from "./SearchOrderHistoryContent";

const SearchOrderHistoryWindow = () => {
  const [searchParams] = useSearchParams();

  return (
    <Box sx={{ height: "100vh", minWidth: 720, p: 2, backgroundColor: "#fff" }}>
      <SearchOrderHistoryContent open initialOrderNo={searchParams.get("orderNo") ?? ""} />
    </Box>
  );
};

export default SearchOrderHistoryWindow;
